import { render, staticRenderFns } from "./CUTextField.vue?vue&type=template&id=63bb8db0&scoped=true"
import script from "./CUTextField.vue?vue&type=script&lang=ts"
export * from "./CUTextField.vue?vue&type=script&lang=ts"
import style0 from "./CUTextField.vue?vue&type=style&index=0&id=63bb8db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb8db0",
  null
  
)

export default component.exports